import { getGrowthFeatureByNameResponseSchema } from './schema';
import { assert } from 'ts-schema';
function getHttpClientMethod(method, hubHttp) {
  if (!hubHttp[method]) {
    throw new Error('Bad endpoint configuration');
  }
  return hubHttp[method];
}
function isURLGenerator(url) {
  if (typeof url === 'function') {
    return true;
  }
  return false;
}
function createClientMethod({
  method,
  url,
  responseSchema,
  requestDataSchema
}) {
  const urlGenerator = isURLGenerator(url) ? url : () => url;
  return ({
    query,
    requestData,
    hubHttp
  } = {}) => {
    const apiClientMethod = getHttpClientMethod(method, hubHttp);
    if (requestDataSchema) {
      assert(requestDataSchema, requestData);
    }
    const apiPromise = apiClientMethod(urlGenerator(query), requestData);
    return apiPromise.then(response => responseSchema ? assert(responseSchema, response) : response);
  };
}

/** get-/feature/store/v1/features/by-feature-name/{featureName} <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:FeaturesResource+type:symbol+getGrowthFeatureByName&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Features-get-%2Ffeature%2Fstore%2Fv1%2Ffeatures%2Fby-feature-name%2F%7BfeatureName%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ffeature%2Fstore%2Fv1%2Ffeatures%2Fby-feature-name%2F%28%28%7BfeatureName%7D%29%29?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span> */
export const getGrowthFeatureByName = createClientMethod({
  method: 'get',
  url: ({
    featureName
  }) => `/feature/store/v1/features/by-feature-name/${featureName}`,
  responseSchema: getGrowthFeatureByNameResponseSchema
});